// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"a3d0a886","143":"f4f7e0aa","265":"6bb74577","485":"7def788c","709":"f8721982","754":"120ea409","787":"544ce7aa","821":"27094461"}[chunkId] + ".chunk.js";
};